import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { rootRoute } from '../root.tsx'

// La scheda della società: real anagrafica, and the two fields a dirigente corrects.
export const officialClubRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialClub,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/club.tsx')),
})

/** The link other pages take the path from, instead of respelling it. */
export const officialClubLink = { to: NAV_PATHS.officialClub } as const
